<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-sliders-h"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle" *ngIf="item">
      {{ item.nome }} | {{ labels.codigo }}: {{ item.codigoItem }} | {{ labels.saldo }}: {{ item.saldo }}
    </p>
  </div>
  <div class="header-actions">
    <button pButton [label]="botoes.voltar" icon="pi pi-arrow-left"
      class="p-button-text"
      [pTooltip]="tooltips.voltar" tooltipPosition="top"
      (click)="voltar()"></button>
    <button pButton [label]="botoes.novo_ajuste" icon="pi pi-plus"
      class="btn-primary"
      (click)="abrirDialog()"></button>
  </div>
</div>

<div class="cards-container">
  <!-- Card: Historico de Ajustes -->
  <div class="table-card">
    <div class="card-header">
      <div class="card-header-icon table-icon">
        <i class="pi pi-history"></i>
      </div>
      <div class="card-header-info">
        <span class="card-header-title">{{ texts.historico }}</span>
        <span *ngIf="item" class="card-header-subtitle">
          {{ labels.codigo }}: {{ item.codigoItem }}
        </span>
      </div>
    </div>
    <div class="card-content">

      <!-- Barra de busca + Seletor de colunas -->
      <div class="search-bar">
        <p-iconField iconPosition="right" class="search-field">
          <p-inputIcon styleClass="pi pi-search" />
          <input pInputText type="text"
            [placeholder]="placeholders.pesquisar"
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange($event)" />
        </p-iconField>

        <app-column-selector
          [columns]="columns"
          [storageKey]="STORAGE_KEY"
          (columnsChange)="onColumnsChange($event)">
        </app-column-selector>
      </div>

      <!-- Tabela -->
      <p-table [value]="ajustes" [loading]="loading"
        (sortFunction)="customSort($event)" [customSort]="true"
        [tableStyle]="{ 'width': '100%' }">

        <ng-template pTemplate="header">
          <tr>
            <th [hidden]="!isColumnVisible('codigoAjusteDeEstoque')" pSortableColumn="codigoAjusteDeEstoque" style="width: 10%">
              {{ labels.codigo }}<p-sortIcon [field]="'codigoAjusteDeEstoque'"></p-sortIcon>
            </th>
            <th [hidden]="!isColumnVisible('tipoOperacao')" style="width: 13%">
              {{ labels.tipo_operacao }}
            </th>
            <th [hidden]="!isColumnVisible('quantidade')" pSortableColumn="quantidade" style="width: 12%">
              {{ labels.quantidade }}<p-sortIcon [field]="'quantidade'"></p-sortIcon>
            </th>
            <th [hidden]="!isColumnVisible('saldoAnterior')" pSortableColumn="saldoAnterior" style="width: 12%">
              {{ labels.saldo_anterior }}<p-sortIcon [field]="'saldoAnterior'"></p-sortIcon>
            </th>
            <th [hidden]="!isColumnVisible('saldo')" pSortableColumn="saldo" style="width: 12%">
              {{ labels.saldo_posterior }}<p-sortIcon [field]="'saldo'"></p-sortIcon>
            </th>
            <th [hidden]="!isColumnVisible('emissao')" pSortableColumn="emissao" style="width: 18%">
              {{ labels.data_emissao }}<p-sortIcon [field]="'emissao'"></p-sortIcon>
            </th>
            <th [hidden]="!isColumnVisible('acoes')" style="width: 8%">
              {{ labels.acoes }}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-ajuste>
          <tr>
            <td [hidden]="!isColumnVisible('codigoAjusteDeEstoque')">{{ ajuste.codigoAjusteDeEstoque }}</td>
            <td [hidden]="!isColumnVisible('tipoOperacao')">
              <span *ngIf="ajuste.tipoOperacaoDeEstoque?.enum === TipoOperacaoDeEstoque.ENTRADA || ajuste.tipoOperacaoDeEstoque === TipoOperacaoDeEstoque.ENTRADA"
                class="badge-tipo badge-entrada">
                <i class="pi pi-arrow-up"></i>
                {{ labels.entrada }}
              </span>
              <span *ngIf="ajuste.tipoOperacaoDeEstoque?.enum === TipoOperacaoDeEstoque.SAIDA || ajuste.tipoOperacaoDeEstoque === TipoOperacaoDeEstoque.SAIDA"
                class="badge-tipo badge-saida">
                <i class="pi pi-arrow-down"></i>
                {{ labels.saida }}
              </span>
            </td>
            <td [hidden]="!isColumnVisible('quantidade')">{{ ajuste.quantidade }}</td>
            <td [hidden]="!isColumnVisible('saldoAnterior')">{{ ajuste.saldoAnterior }}</td>
            <td [hidden]="!isColumnVisible('saldo')">
              <span class="saldo-com-icone">
                {{ ajuste.saldo }}
                <i *ngIf="ajuste.tipoOperacaoDeEstoque?.enum === TipoOperacaoDeEstoque.ENTRADA || ajuste.tipoOperacaoDeEstoque === TipoOperacaoDeEstoque.ENTRADA"
                  class="pi pi-arrow-up saldo-icone-entrada"></i>
                <i *ngIf="ajuste.tipoOperacaoDeEstoque?.enum === TipoOperacaoDeEstoque.SAIDA || ajuste.tipoOperacaoDeEstoque === TipoOperacaoDeEstoque.SAIDA"
                  class="pi pi-arrow-down saldo-icone-saida"></i>
              </span>
            </td>
            <td [hidden]="!isColumnVisible('emissao')">{{ ajuste.emissao | date:'dd/MM/yyyy HH:mm' }}</td>
            <td [hidden]="!isColumnVisible('acoes')">
              <button pButton icon="pi pi-trash"
                class="p-button-text p-button-rounded p-button-sm p-button-danger"
                [pTooltip]="tooltips.excluir" tooltipPosition="top"
                (click)="confirmarExclusao(ajuste)"></button>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
              <div class="flex flex-column align-items-center">
                <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                <div class="text-gray-500 text-lg">{{ texts.sem_registros }}</div>
                <div class="text-gray-400 text-sm mt-1">{{ texts.ajuste_filtros }}</div>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="loadingbody">
          <tr>
            <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
              <div class="flex justify-content-center align-items-center">
                <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                <span class="ml-3">{{ texts.carregando }}</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- Paginacao -->
      <div class="pagination-container">
        <div>
          <p-paginator (onPageChange)="onPageChange($any($event))"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} de {totalRecords}"
            [first]="first" [rows]="rows"
            [totalRecords]="totalRecords" [showFirstLastIcon]="true">
          </p-paginator>
        </div>
        <div class="flex align-items-center">
          <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
          <p-dropdown [options]="pageSizeOptions" optionLabel="label"
            optionValue="value" [(ngModel)]="rows"
            (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
          </p-dropdown>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Dialog de Criacao -->
<p-dialog [(visible)]="dialogVisible"
  [header]="botoes.novo_ajuste"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [style]="{ width: '450px' }">

  <div class="dialog-form">
    <div class="field">
      <label for="tipoOperacao">{{ labels.tipo_operacao }} *</label>
      <p-dropdown [options]="tiposOperacao"
        [(ngModel)]="form.tipoOperacaoDeEstoque"
        optionLabel="label"
        [placeholder]="labels.tipo_operacao"
        [style]="{ width: '100%' }"
        appendTo="body" panelStyleClass="dropdown-panel-above-modal">
      </p-dropdown>
    </div>

    <div class="field">
      <label for="quantidade">{{ labels.quantidade }} *</label>
      <app-input-quantidade [(ngModel)]="form.quantidade"
        [casasDecimais]="casasDecimaisQuantidade"
        [style]="{ width: '100%' }">
      </app-input-quantidade>
    </div>

    <div class="field">
      <label for="tipoConta">{{ labels.tipo_conta }}</label>
      <p-dropdown [options]="tiposConta"
        [(ngModel)]="form.tipoContaEstoque"
        optionLabel="label"
        [placeholder]="labels.tipo_conta"
        [style]="{ width: '100%' }"
        appendTo="body" panelStyleClass="dropdown-panel-above-modal">
      </p-dropdown>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.cancelar" class="p-button-secondary"
      (click)="fecharDialog()"></button>
    <button pButton [label]="botoes.salvar" icon="pi pi-check"
      [disabled]="saving || !form.tipoOperacaoDeEstoque || !form.quantidade || form.quantidade < 1"
      [loading]="saving"
      (click)="submit()"></button>
  </ng-template>
</p-dialog>

<!-- Dialog de Confirmacao de Exclusao -->
<p-confirmDialog></p-confirmDialog>

<p-toast></p-toast>
